import { query } from '@confluence/query-preloader-tools';

import { PageStatusQuery } from '../graphql/PageStatusQuery.graphql';

// Dev note: If this is changed, also update `preloadPageStatusQuery` in preloadLivePageRoute.ts
export function preloadPageStatusQuery(contentId: string) {
	return query({
		query: PageStatusQuery,
		variables: {
			contentId,
		},
	});
}
